import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZencargoSplash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 160,
	height: 160,
	viewBox: "0 0 160 160",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: "\n    .zs-flip,\n    .zs-shadow,\n    .zs-spk {\n      transform-box: fill-box;\n      transform-origin: center;\n    }\n\n    .zs-flip {\n      animation: zs-flip 2.4s infinite;\n    }\n\n    .zs-shadow {\n      animation: zs-shadow 2.4s infinite ease-in-out;\n    }\n\n    .zs-mark {\n      animation: zs-mark 2.4s infinite step-end;\n    }\n\n    .zs-luca {\n      animation: zs-luca 2.4s infinite step-end;\n    }\n\n    .zs-spk {\n      animation: zs-sparkle 1.2s infinite ease-in-out;\n    }\n\n    .zs-flip,\n    .zs-shadow,\n    .zs-mark,\n    .zs-luca,\n    .zs-spk {\n      animation-delay: var(--zs-offset, 0s);\n    }\n\n    .zs-spk.b {\n      animation-delay: calc(var(--zs-offset, 0s) - 0.8s);\n    }\n\n    .zs-spk.c {\n      animation-delay: calc(var(--zs-offset, 0s) - 0.4s);\n    }\n\n    @keyframes zs-flip {\n      0%,\n      50% {\n        transform: scaleX(1);\n        animation-timing-function: cubic-bezier(0.65, 0, 1, 1);\n      }\n\n      10%,\n      60% {\n        transform: scaleX(0);\n        animation-timing-function: cubic-bezier(0, 0, 0.35, 1);\n      }\n\n      20%,\n      70%,\n      100% {\n        transform: scaleX(1);\n      }\n    }\n\n    @keyframes zs-shadow {\n      0%,\n      20%,\n      50%,\n      70%,\n      100% {\n        transform: scaleX(1);\n      }\n\n      10%,\n      60% {\n        transform: scaleX(0.343);\n      }\n    }\n\n    @keyframes zs-mark {\n      0% {\n        opacity: 1;\n      }\n\n      10% {\n        opacity: 0;\n      }\n\n      60%,\n      100% {\n        opacity: 1;\n      }\n    }\n\n    @keyframes zs-luca {\n      0% {\n        opacity: 0;\n      }\n\n      10% {\n        opacity: 1;\n      }\n\n      60%,\n      100% {\n        opacity: 0;\n      }\n    }\n\n    @keyframes zs-sparkle {\n      0%,\n      100% {\n        transform: scale(0.4);\n        opacity: 0.3;\n      }\n\n      50% {\n        transform: scale(1.15);\n        opacity: 1;\n      }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .zs-flip,\n      .zs-shadow,\n      .zs-mark,\n      .zs-luca,\n      .zs-spk {\n        animation: none;\n      }\n    }\n  " }),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "zs-g0",
			x1: 6,
			y1: 36.9,
			x2: 55.9,
			y2: 36.9,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#9573DA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#C476D2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF6A7F"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "zs-g1",
			x1: 35.1,
			y1: 45.3,
			x2: 55.9,
			y2: 45.3,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9958A5" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CC6683"
			})]
		})] }),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "zs-shadow",
			cx: 80,
			cy: 140,
			rx: 35,
			ry: 4,
			fill: "#080E49",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(80 66)",
			children: /* @__PURE__ */ _jsxs("g", {
				className: "zs-flip",
				children: [/* @__PURE__ */ _jsxs("g", {
					className: "zs-mark",
					fill: "#0E177A",
					transform: "scale(1.6) translate(-25 -27)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							transform: "translate(1.145 0)",
							d: "M48.855 17.293L20.502 0L0 11.564L28.299 28.91Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							transform: "translate(0 13.739)",
							d: "M28.135 17.24L0 0L0 23.022L28.135 40.155Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							transform: "translate(30.643 32.411)",
							d: "M0 0L0 21.589L19.248 10.821Z"
						})
					]
				}), /* @__PURE__ */ _jsxs("g", {
					className: "zs-luca",
					opacity: 0,
					transform: "scale(1.375) translate(-32 -32)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							className: "zs-spk",
							fill: "#C476D2",
							d: "M50.7 8c0-.1-.1-.2-.2-.2l-1.8-.5c-1.7-.5-3-1.8-3.5-3.5L44.7 2c0-.2-.3-.3-.5-.2 0 0-.2.1-.2.2l-.5 1.8c-.5 1.7-1.8 3-3.5 3.5l-1.8.5c-.2 0-.3.2-.2.4 0 .1.1.2.2.2l1.8.5c1.7.5 3 1.8 3.5 3.5l.5 1.8c0 .2.2.3.4.2.1 0 .2-.1.2-.2l.5-1.8c.5-1.7 1.8-3 3.5-3.5l1.8-.5c.2 0 .3-.2.2-.4z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "zs-spk b",
							fill: "#C476D2",
							d: "M49.1 2.2h1.3v1.3c0 .2.1.3.3.3s.3-.1.3-.3V2.2h1.3c.2 0 .3-.1.3-.3s-.1-.3-.3-.3H51V.3c0-.2-.1-.3-.3-.3s-.3.1-.3.3v1.3h-1.3c-.2 0-.3.1-.3.3s.1.3.3.3z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "zs-spk c",
							fill: "#C476D2",
							d: "M53.3 14.5l-.8-.2c-.7-.2-1.3-.8-1.5-1.5l-.2-.8h-.2l-.2.8c-.2.7-.8 1.3-1.5 1.5l-.8.2v.2l.8.2c.7.2 1.3.8 1.5 1.5l.2.8h.2l.2-.8c.2-.7.8-1.3 1.5-1.5l.8-.2v-.2z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "url(#zs-g0)",
							d: "M55.3 26.3L28.6 9.9c-.4-.2-.8-.2-1.2 0L6.6 22c-.4.2-.6.6-.6 1v22.1c0 .4.2.8.5 1l28.1 17.7c.4.2.8.2 1.2 0l19.5-10.9c.4-.2.6-.6.6-1V27.2c0-.4-.2-.8-.5-1z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#080E49",
							d: "M15 31.9c1 0 1.9.8 1.9 1.9V37c0 1-.8 1.9-1.9 1.9-1 0-1.9-.8-1.9-1.9v-3.2c0-1 .8-1.9 1.9-1.9z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "#080E49",
							d: "M24.4 37.9c1 0 1.9.8 1.9 1.9V43c0 1-.8 1.9-1.9 1.9-1 0-1.9-.8-1.9-1.9v-3.2c0-1 .8-1.9 1.9-1.9z"
						}),
						/* @__PURE__ */ _jsx("path", {
							fill: "url(#zs-g1)",
							d: "M35.8 63.9L55.3 53c.4-.2.6-.6.6-1V27.3c0-.3 0-.5-.2-.7l-20 10.1c-.4.2-.6.6-.6 1v26.4c.2 0 .5 0 .7-.1z"
						})
					]
				})]
			})
		})
	]
});
export default SvgZencargoSplash;
